/* @flow */
import React, { useContext } from "react";
import prefixStyles from "nx-components/utils/prefixStyles";
import DetailsHeaderWrapper, {
  DetailsHeaderOffscreenOverscroll,
} from "nexia_mobile/components/Details/DetailsHeaders/DetailsHeaderWrapper";
import UserIcon from "nexia_mobile/components/UserIcon";
import type Phone from "nexia_mobile/models/phone";
import UserLanguageContext from "nx-components/ContextWrappers/UserLanguageContext";

const styles = prefixStyles({
  iconStyle: {
    fontSize: "5em",
  },
});

type Props = {
  model: Phone,
};

const PhoneHeader = (props: Props) => {
  const languageContext = useContext(UserLanguageContext);
  const language = languageContext.localeSet.nexia_mobile.PhoneHeader;
  return (
    <div data-component-name="PhoneHeader">
      <DetailsHeaderOffscreenOverscroll />
      <DetailsHeaderWrapper>
        <UserIcon phone={props.model} style={styles.iconStyle} />
        <div className="details-status-description">
          {language.mobileUserLabel}
        </div>
      </DetailsHeaderWrapper>
    </div>
  );
};

export default PhoneHeader;



// WEBPACK FOOTER //
// ./src/components/Details/DetailsHeaders/PhoneHeader.jsx